module.exports = "/_next/static/images/3d1a841a7eab8f2957c78a92e26b556c-cfe-icon.svg";